import { HttpContextToken } from '@angular/common/http';

export const IsFormDataEnabled = new HttpContextToken<boolean>(() => false);
